import axios from 'axios';

export default {
    name: 'groups',
    data() {
        return {
            auth: this.$parent.auth,
            category: this.$parent.selectedCategory,
            groups: {},
            groupsHeaders: [
                { name: 'groupName', label: this.$t('HC_GROUP') },
                { name: 'name', label: this.$t('HC_NAME') },
                { name: 'brand', label: this.$t('HC_BRAND') },
                { name: 'model', label: this.$t('HC_MODEL') },
                { name: 'qicName', label: this.$t('HC_PM_TAG') },
                { name: 'itemCount', label: this.$t('HC_ASSET_COUNT') },
                { name: 'workOrders', label: this.$t('HC_WORK_ORDERS') }
            ],
            searchQuery: '',
            propertyName: this.$parent.propertyName,
            currentPage: 0,
            pageSize: 20,
            minPageSize: 20,
            actions: [{ name: 'View' }],
            historyStack: [
                { name: 'Assets', view: 'assets' },
                { name: this.$parent.selectedCategory.name, url: '#' }
            ]
        };
    },
    created() {
        this.getSelectedAssetTypesByCategory(this.category.id);
    },
    methods: {
        getSelectedAssetTypesByCategory(categoryId) {
            axios
                .get(
                    this.auth.v4.url +
                        `/item-categories/${categoryId}/item-types?orderBy=groupName`,
                    {
                        headers: {
                            'x-api-key': this.auth.v4.token
                        }
                    }
                )
                .then(result => {
                    let results = result.data.data;
                    this.groups = results;
                })
                .catch(() => this.$parent.showAlert());
        },
        handleActionClick(item) {
            // item is the object representation of the clicked row
            // an action param is available if there is more than 1 action in the column
            this.$emit('currentView', 'assets-by-type');
            this.$emit('selectedType', item);
            this.$emit('currentTransition', 'component-slide-fade-up');
        }
    }
};
